module.exports = "<div class=\"valuebar\" ng-class=\"{'high': $ctrl.barColor>0.66, 'medium': ($ctrl.barColor>=0.33 && $ctrl.barColor<=0.66), 'low': $ctrl.barColor<0.33 }\" style=\"width:{{$ctrl.relative * 100}}%;\" ng-if=\"$ctrl.relative\">\n\t<span class=\"bar-value\" ng-if=\"$ctrl.relative > 0.33\">\n\t\t{{$ctrl.display}}\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t</span>\n</div>\n<span class=\"bar-value\" ng-if=\"$ctrl.display && $ctrl.relative < 0.33\">\n\t{{$ctrl.display}}\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n</span>  \n\n<div ng-if=\"!$ctrl.relative\">{{$ctrl.display}}</div>"


//////////////////
// WEBPACK FOOTER
// ./app/components/valuebar/valuebar.html
// module id = 427
// module chunks = 0